import { ABSENCE_LETTER_VERSION } from "../../../../../constants/version";
import AbsenceLetterV2 from "../../absence-letter";
import AbsenceLetter from "../../absence-letter-v1";
import AbsenceLetterCreate from "../../absence-letter/pages/absence-letter/absence-letter-create";
import AbsenceLetterDetail from "../../absence-letter-v1/pages/absence-letter/absence-letter-detail";
import AbsenceLetterDetailV2 from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import AbsenceLetterEdit from "../../absence-letter/pages/absence-letter/absence-letter-edit";

export const absenceLetterRoutes = {
  absenceLetterPage: {
    isAdmin: false,
    title: "1. Đơn xin nghỉ phép",
    path: "/procedure/absence-letter",
    parentId: "procedure",
    component: ABSENCE_LETTER_VERSION === 1 ? AbsenceLetter : AbsenceLetterV2,
    //   () => {
    //     return (
    //       <AbsenceLetter />

    //       // <Permission record={{ [PERMISSIONS["ABSENCE_LETTER"]]: ({ R }) => R }} fallback={<NotAllowed />}>
    //       //   <AbsenceLetter />
    //       // </Permission>
    //     );
    // },
  },
  createAbsenceLetterPage: {
    isAdmin: false,
    path: "/procedure/absence-letter/create",
    parentId: "procedure",
    component: AbsenceLetterCreate,
  },
  detailAbsenceLetterPage: {
    isAdmin: false,
    path: "/procedure/absence-letter/:applicationForLeaveId",
    parentId: "procedure",
    component: ABSENCE_LETTER_VERSION === 1 ? AbsenceLetterDetail : AbsenceLetterDetailV2,
  },
  editAbsenceLetterPage: {
    isAdmin: false,
    path: "/procedure/absence-letter/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: AbsenceLetterEdit,
  },
};
